const convertSlugToNormalTextAccessories = (slug: string) => {
  return slug.replace(/--/g, 'temp').replace(/-/g, ' ').replace(/temp/g, '-');
};

export default convertSlugToNormalTextAccessories;
